import RestClient from './RestClient';
import { PdfLayout } from '../../models';
import * as _ from 'es-toolkit';

class PdfLayouts extends RestClient {
    constructor() {
        super({
            "model": PdfLayout,
            "entryPoint": "layout",
            "resource": "layout",
            "resources": "layouts",
            "id_field": "_id",
        });
    }

    // TODO: rename to list when all Ticketack instances are up to date
    ___list(params) {
        // remove empty filter values
        params = _.pickBy(params, _.identity) || {};
        params.layout_type = 'pdf';
        return super.list(params);
    }

    /**
     * Render a PDF preview from a layout draft and simulation context.
     *
     * @param {Object} layout layout draft (pages + widgets)
     * @param {String} lang preview language
     * @param {Object} context simulation context
     * @return {Promise<Blob>}
     */
    previewPdf(layout, lang, context) {
        return this.POST('/layout/preview_pdf', { layout, lang, context }, null, {
            Accept: 'application/pdf',
        }).then(async (response) => {
            if (response.ok)
                return response.blob();

            let message = 'Unable to generate PDF preview';
            try {
                const json = await response.json();
                message = json?.flash?.error || message;
            } catch (e) {
                // ignore parse errors on non-json bodies
            }
            throw new Error(message);
        });
    }
}

const PdfLayoutsApi = new PdfLayouts();

export default PdfLayoutsApi;
